import { Radio as RadioMaterial } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';

interface IProps {
    onChange?: (value: boolean) => void;
    value: string;
    icon?: 'circle' | 'check';
    size?: number;
}
export const Radio: FC<IProps> = ({ onChange, value, icon = 'circle', size = 16 }) => {
    return (
        <RadioMaterial
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange && onChange(e.target.checked)}
            value={value}
            checkedIcon={
                <i
                    className={icon === 'check' ? 'fas fa-check-circle' : 'far fa-dot-circle'}
                    style={{ color: Colors.mediumPurpleViolet, fontSize: size }}
                />
            }
            icon={<i className="fal fa-circle" style={{ fontSize: size }} />}
            sx={{
                color: Colors.linkWater,
                p: 0.2
            }}
        />
    );
};
